import { useState } from 'react';

import SafariPortalLogo from 'components/shared/images/safari_portal.svg';
import Text from 'components/shared/Typography/Text';
import i18n from 'i18n';

import { replaceHost } from '../../shared/Logo';
import { THeaderLeftSide, THeaderRightSide, TLogo } from '../../shared/types';
import s from './index.module.css';

export const renderLogoImage = ({ logo, companyName }: TLogo) => <LogoImage logo={logo} companyName={companyName} />;

const LogoImage = (props: TLogo) => {
  const [logo, setLogo] = useState<string | undefined>(replaceHost(props.logo));
  const resetLogo = () => setLogo(SafariPortalLogo);

  return (
    <img src={logo + '?pdf'} alt={props.companyName} style={{ maxWidth: 125, maxHeight: 75 }} onError={resetLogo} />
  );
};

export const renderLeftContentDefault = ({ preparedFor, title, travelDates }: THeaderLeftSide) => (
  <>
    {preparedFor && (
      <Text className={s.text} accent>{`${i18n.t('proposal_content.prepared_for')} ${preparedFor}`}</Text>
    )}
    <Text className={s.text} accent>
      {title}
    </Text>
    <Text className={s.text} accent>
      {travelDates}
    </Text>
  </>
);

export const renderRightContentDefault = ({ companyName, email, phone }: THeaderRightSide) => (
  <>
    <Text className={s.text} accent>
      {companyName}
    </Text>
    <Text className={s.text} accent>
      {email}
    </Text>
    <Text className={s.text} accent>
      {phone}
    </Text>
  </>
);
